<template>
  <div>
    <div v-if="show">
      <template v-if="$has('FWS-KJSH-TKSH-TGBH')">
        <el-button
          class="table-button table-button-success"
          icon="el-icon-success" @click="handleOperateState(1, current)"
          v-track
          trackCode='approvalRefundLists-4'
        >
          通过
        </el-button>
        <el-button
          class="table-button table-button-danger"
          icon="el-icon-delete-solid" @click="handleOperateState(2, current)"
          v-track
          trackCode='approvalRefundLists-4'
        >
          驳回
        </el-button>
      </template>
      <el-button
        class="table-button table-button-danger"
        icon="el-icon-error" @click="handleOperateState(3, current)"
        v-if="$has('FWS-KJSH-TKSH-QX')"
        v-track
        trackCode='approvalRefundLists-5'
      >
        取消
      </el-button>
    </div>
    <operate-dialog
      :visible.sync="isOperateStateShow"
      :data-obj.sync="refundObj"
      :text-config.sync="textConfig"
      :loading="submitLoading"
      @submit="setRefundApproval"
    />
  </div>
</template>

<script>
import { setRefundApproval } from '@/api/refund';

export default {
  props: {
    current: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOperateStateShow: false,
      refundObj: {},
      textConfig: {},
      submitLoading: false,
    };
  },
  methods: {
    handleOperateState(operation, row) {
      this.refundObj = {
        refundApplyNo: row.refundApplyNo,
        operation,
        cancelRemark: '',
      };
      const list = {
        1: {
          title: '审核通过确认',
          messageTip: '是否通过该审核？',
          isPass: true,
        },
        2: {
          title: '审核驳回',
          messageTip: '驳回原因',
          isPass: false,
          required: true,
        },
        3: {
          title: '提示',
          messageTip: '是否取消该退款审核，取消后无法撤销',
          isPass: true,
        },
      };
      this.textConfig = list[operation] || '-';
      this.isOperateStateShow = true;
    },
    async setRefundApproval(params) {
      try {
        this.submitLoading = true;
        await setRefundApproval(params);
        this.$message.success('操作成功！');
        this.submitLoading = false;
        this.isOperateStateShow = false;
        this.$emit('success');
      } catch (error) {
        console.log(error);
        this.submitLoading = false;
      }
    },
  },
};
</script>
